import { useEffect } from 'react';
import create from 'zustand';

const initialState = { isOnline: true };

type OnlineStatusState = typeof initialState & {
  goOffline: () => void;
  goOnline: () => void;
};

const useOnlineStatusState = create<OnlineStatusState>((set) => ({
  ...initialState,
  goOffline: () => set((_) => ({ isOnline: false })),
  goOnline: () => set((_) => ({ isOnline: true })),
}));

export const useTrackOnlineStatus = () => {
  const { goOffline, goOnline } = useOnlineStatusState();

  return useEffect(() => {
    window.addEventListener('offline', goOffline);
    window.addEventListener('online', goOnline);

    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online', goOnline);
    };
  }, [goOffline, goOnline]);
};

export const useOnlineStatus = () => useOnlineStatusState((s) => s.isOnline);
